/**
 * Consumer-friendly guarantee type descriptions
 * Replaces technical terms with plain English for consumer portal
 * @see Issue #1199
 */

const GUARANTEE_DESCRIPTIONS: Record<string, string> = {
  full_recourse: 'You are personally guaranteeing the full loan amount',
  partial_recourse: 'You are guaranteeing a portion of the loan',
  payment: 'You guarantee the loan payments will be made on time',
  completion: 'You guarantee the project will be completed',
  carve_out: 'You guarantee specific exceptions in the loan agreement',
};

const ROLE_DESCRIPTIONS: Record<string, string> = {
  primary_borrower: 'You are the primary borrower on this loan',
  co_borrower: 'You are a co-borrower on this loan',
  sponsor: 'You are a sponsor for this loan',
};

export function getGuaranteeDescription(type: string, amount?: number | null): string {
  const base = GUARANTEE_DESCRIPTIONS[type] ?? `You have a ${type.replace(/_/g, ' ')} guarantee`;
  if (amount && amount > 0) {
    return `${base} ($${amount.toLocaleString()})`;
  }
  return base;
}

export function getRoleDescription(role: string): string {
  return ROLE_DESCRIPTIONS[role] ?? `You are listed as ${role.replace(/_/g, ' ')} on this loan`;
}
